module.exports = __webpack_public_path__ + "img/kvikkleirerapport.5a46c07f.jpg";